<template>
  <el-container class="base-container">
    <el-main class="p-none">
      <el-main style="padding-bottom: 0">
        <Sticky :z-index="10" :sticky-top="50" class-name="filter-panel">
          <FilterPanel
            :id="id"
            v-model="filter"
            :type="type"
            @update="update"
          />
        </Sticky>
      </el-main>
      <el-main>
        <HistoryTable v-loading="loading" :items="items" @load="load" />
      </el-main>
      <el-main style="padding-top: 0">
        <Pagination
          v-if="total > 0"
          :total="total"
          :page="page"
          @pagination="update"
        />
      </el-main>
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { computed, ref, defineComponent, onMounted } from 'vue'
import HistoryTable from './components/HistoryTable.vue'
import FilterPanel from './components/FilterPanel.vue'
import { useVersionsStore } from '@/apps/traforama/store/versions'
import { IVersionsFilter } from '@/apps/traforama/interfaces/versions'
import Pagination from '@/components/Pagination.vue'
import Sticky from '@/components/Sticky.vue'

export default defineComponent({
  name: 'Versions',
  components: {
    HistoryTable,
    FilterPanel,
    Pagination,
    Sticky
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const versionsStore = useVersionsStore()

    const total = computed(() => versionsStore.total)
    const items = computed(() => versionsStore.currentItems)
    const page = computed(() => versionsStore.currentPage)
    const loading = computed(
      () =>
        Object.keys(versionsStore.itemsLoading).length > 0 ||
        versionsStore.listLoading
    )
    const filter = computed({
      get: () => versionsStore.filter,
      set: (val: IVersionsFilter) => versionsStore.SetFilters(val)
    })

    const update = ({
      limit = 15,
      newPage = 1
    }: {
      limit?: number
      newPage?: number
    }) => {
      versionsStore.SetCurrentPage(newPage)
      versionsStore.FetchItems()
    }

    const reset = () => {
      filter.value = {}
      update({})
    }

    onMounted(() => {
      filter.value = {
        item_type: props.type,
        item_id: props.id
      }
      update({})
    })

    const load = (id: string) => {
      versionsStore.FetchItem(id)
    }

    return {
      loading,
      page,
      update,
      items,
      total,
      load,
      filter
    }
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-card.is-always-shadow) {
  box-shadow: none;
}
</style>
